import type { ManufacturerType } from "../components/ManufacturerBenchmarkingChart/ManufacturerBenchmarkingChart";

export const EXPLORER_BASE_PATH = "/explorer";

export const COMMERCIAL_TAB_TITLE = "Commercial";
export const COMMERCIAL_VIEW = "commercial";
export const TECHNICAL_INSIGHTS_TAB_TITLE = "Technical";
export const TECHNICAL_INSIGHTS_VIEW = "technical-insights";
export const BENCHMARKING_TAB_TITLE = "Benchmarking";
export const BENCHMARKING_VIEW = "benchmarking";

export const TOTAL_PENALTY = "total_penalty";
export const ANNUALISED_PENALTIES = "annualised_penalties";
export const PENALTIES_PROPORTION_TOTAL_REVENUE =
  "penalties_proportion_total_revenue";
export const PENALTIES_PROPORTION_MAX_PENALTY =
  "penalties_proportion_max_penalty";
export const K_FACTOR = "K-factor";
export const POWER_UNAVAILABILITY = "Power unavailability";
export const MISSING_PERFORMANCE_FILE = "Missing performance file";
export const SOE_MANAGEMENT = "SoE management";
export const DCL_AVAILABILITY_RATIO = "DCL availability ratio";
export const DCH_AVAILABILITY_RATIO = "DCH availability ratio";
export const DMH_AVAILABILITY_RATIO = "DMH availability ratio";
export const DML_AVAILABILITY_RATIO = "DML availability ratio";
export const DRH_AVAILABILITY_RATIO = "DRH availability ratio";
export const DRL_AVAILABILITY_RATIO = "DRL availability ratio";
export const DXL_K_COEFFICIENT = "DXL K coefficient";
export const DXH_K_COEFFICIENT = "DXH K coefficient";

export const DURATION = "duration";
export const ENERGY_VOLUME = "energy_volume";
export const DX_CONTRACTED_POWER_DURATION = "dx_contracted_power_duration";
export const DX_CONTRACTED_POWER_ENERGY_VOLUME =
  "dx_contracted_power_energy_volume";
export const NAMEPLATE_POWER_DURATION = "nameplate_power_duration";
export const NAMEPLATE_POWER_ENERGY_VOLUME = "nameplate_power_energy_volume";

export const SOE_MWH_AVG = "SoE";
export const REV_MIN_SOE_MWH_AVG = "SoE export limit";
export const REV_MAX_SOE_MWH_AVG = "SoE import limit";
export const ENERGY_CAPACITY_MWH_AVG = "Energy capacity";
export const NULL_STRING = "--";

export const MISDELIVERY_THRESHOLD_PERCENTAGE = 0.03;
export const ALL_CAUSES_NAME = "All causes";
export const ALL_CAUSES_VALUE = "all_causes";

export const NET_CASHFLOW_SERIES_NAME = "Net cashflow";
export const NET_CASHFLOW_LINE_COLOR = "#007bff";
export const NET_CASHFLOW_POINT_COLOR = "#000";
export const NET_CASHFLOW_ERROR_SERIES_NAME = "Net cashflow error";

export const MANUFACTURER_TYPE_INVERTER: ManufacturerType = "inverter";
export const MANUFACTURER_TYPE_BATTERY: ManufacturerType = "battery";
